export default {"src":"/_next/static/media/add-item.4f0841c6.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};